import { render, staticRenderFns } from "./LaboratoryForms.vue?vue&type=template&id=525a5368&"
import script from "./LaboratoryForms.vue?vue&type=script&lang=js&"
export * from "./LaboratoryForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports